/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { useContext } from "react";
import { MsalContext } from "../MsalContext";
/**
 * Returns Msal Context values
 */
export const useMsal = () => useContext(MsalContext);
//# sourceMappingURL=useMsal.js.map